import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// Only redirects, so any signed-in user may open it: the dashboard checks its own access.
export const Route = createFileRoute('/_authenticated/next/assemblies/$assemblyId/')({
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/assemblies/$assemblyId/dashboard',
            params: { assemblyId: params.assemblyId },
            replace: true,
        });
    },
});
